import React from "react";

import "./styles/work.css";

const Work = ({ company, role, duration, description, logo }) => {
  return (
    <div className="work">
      <div className="work-header">
        <div className="work-company-image">
          <img src={logo} alt={company} />
        </div>
        <div className="work-details">
          <h3 className="work-company">{company}</h3>
          <p className="work-role">{role}</p>
          <p className="work-duration">{duration}</p>
        </div>
        <div className="point"></div>
      </div>
      <div className="work-description">
        <ul>
          {description.map((line, index) => (
            <li key={index}>{line}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Work;
